import type { SearchFilterField } from 'lib-search-types';
import moment, { Moment } from 'moment-timezone';

import styles from '../conditionFieldDate.module.scss';

const maxDate = moment().add(1, 'day');

/** The date fields that hold future dates, like when a follow up ends. */
const futureDateFields: ReadonlySet<SearchFilterField<'conversations'>> =
  new Set(['pending_expiration_at']);

/** Returns the latest date that can be picked for a field, with no limit for fields that hold future dates. */
export const getMaxDate = (
  field: SearchFilterField<'conversations'>,
): Moment | undefined => (futureDateFields.has(field) ? undefined : maxDate);

export const timePickerProps = {
  clearable: true,
  className: styles.timePicker,
};
